import React from "react";

export default function DisruptorIcon(props: React.SVGProps<any>) {
  return (
    <svg width={40} height={40} viewBox="0 0 40 40" fill="none" {...props}>
      <circle cx={20} cy={20} r={20} fill="url(#fa4w4iq4kmna)" />
      <path
        d="M20.533 28c5.016 0 8.496-3.168 8.496-7.992s-3.48-8.016-8.496-8.016H14.22V28h6.312zm0-3h-2.904V14.992h2.904c3.288 0 5.016 2.184 5.016 5.016C25.549 22.72 23.7 25 20.533 25z"
        fill="#fff"
      />
      <defs>
        <linearGradient id="fa4w4iq4kmna" x1={-1.973} y1={40} x2={44.334} y2={37.998} gradientUnits="userSpaceOnUse">
          <stop stopColor="#FE5F51" />
          <stop offset={1} stopColor="#FE8F51" />
        </linearGradient>
      </defs>
    </svg>
  );
}
